import { useMemo } from "react";
import { map, toNumber } from "lodash";
import { useTeamsQuery, Team } from "@/features/teams/graphql/generated";
import { usePeople } from "@/features/people/hooks/usePeople";
import { Person } from "@/features/people/graphql/generated";
import { useOrganisation } from "@/features/organization/hooks/useOrganisation";

export interface TeamType extends Omit<Team, "members"> {
  id: number;
  members: Person[];
}

export const useTeams = (orgId?: number, personId?: number) => {
  const { organization } = useOrganisation();
  const organizationId = orgId || organization?.id;

  const { data, loading } = useTeamsQuery({
    variables: {
      filter: {
        org_id: organizationId!,
        person_id: personId || null,
      },
    },
    skip: !organizationId,
  });

  const { people, loading: loadingPeople } = usePeople({
    org_id: organizationId,
  });

  const teams = useMemo(
    () =>
      map(data?.teams, (team: Team) => ({
        ...team,
        members: people.filter((person: Person) =>
          team.members?.includes(toNumber(person?.id))
        ),
      })) as unknown as TeamType[],
    [data?.teams, people]
  );

  return { teams, loading: loading || loadingPeople };
};
